var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('ul',_vm._l((_vm.breadcrumbs),function(breadcrumb,idx){return _c('li',{key:idx,class:{'linked': !!breadcrumb.link},on:{"click":function($event){return _vm.routeTo(idx)}}},[_vm._v(_vm._s(breadcrumb.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }